import { environ } from "@ihr-radioedit/sdk-utils";
import axios from "axios";
import * as qs from "qs";
import { HTTPError } from "./errors";
export class Connection {
    constructor(config = {}, interceptors = []) {
        this.config = config;
        this.interceptors = interceptors;
        this.client = this.create(config, interceptors);
    }
    get http() {
        return this.client;
    }
    create(config, interceptors) {
        config = this.modifyConfig(config);
        interceptors = this.modifyIntercepts(interceptors);
        const client = axios.create(config);
        if (interceptors) {
            interceptors.forEach(({ onFulfilled, onRejected }) => {
                client.interceptors.request.use(onFulfilled, onRejected);
            });
        }
        // NOTE: This interceptor wraps the standard axios response/error into an easier to use HTTPError
        client.interceptors.response.use(response => response, error => Promise.reject(HTTPError.fromAxiosResponse(error)));
        return client;
    }
    // Designed to be overridden in base classes
    modifyConfig(config) {
        return {
            headers: {},
            proxy: this.detectProxy(),
            paramsSerializer: params => qs.stringify(params, { encode: false }),
            // cancelToken: this._cancel.token,
            ...config,
        };
    }
    // Designed to be overridden in base classes
    modifyIntercepts(interceptors) {
        return interceptors;
    }
    detectProxy() {
        const proxyURL = environ.get("HTTP_PROXY", "");
        if (proxyURL) {
            const { hostname, port } = new URL(proxyURL);
            return {
                host: hostname,
                port: parseInt(port, 10),
            };
        }
        return false;
    }
}
//# sourceMappingURL=connection.js.map